import _ from 'lodash';
import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import DateTime from "@/components/DateTime"
import dayjs from "dayjs"
import { getQuery } from '@/utils';
import { getDistributeUserInfo } from '@/pages/leads/distribution/api';

class UserInfo extends React.Component {
  static propTypes = {
    userId: PropTypes.number,
    user: PropTypes.shape({
      displayName: PropTypes.string,
      avatar: PropTypes.string,
    }),
    showName: PropTypes.bool,
  }

  static defaultProps = {
    showName: true,
  }

  constructor() {
    super();
    this.state = {
      user: {},
    };
  }

  // 根据服务商id获取用户信息
  getUserInfoWithAgencyId(userId) {
    const agencyId = getQuery('agencyId');
    if(agencyId) {
      // 有agencyId 调用新接口 by fightingliu
      getDistributeUserInfo({ agencyId, userId }).then((res) => {
        this.setState({
          user: res,
        });
      });
      // console.log(`调用新接口获取用户信息, 服务商ID: ${agencyId}`);
      return true;
    }
    return false;
  }
  componentDidMount() {
    const { webApi, userId, user } = this.props
    if (!user && userId) {
      if(this.getUserInfoWithAgencyId(userId)) return;
      webApi.getUserIfNeed(userId).dispatch(ActionTypes.FETCH_USER)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userId, userRepo, webApi } = this.props
    if (nextProps.userId !== userId) {
      if (!userRepo[nextProps.userId]) {
        if(this.getUserInfoWithAgencyId(nextProps.userId)) return;
        webApi.getUserIfNeed(nextProps.userId).dispatch(ActionTypes.FETCH_USER)
      }
    }
  }

  render() {
    const { userId, showName } = this.props
    const { user } = getQuery('agencyId') ? this.state : this.props;
    let name = user ? user.displayName : undefined
    if (name && name === "???") {
      name = undefined
    }
    let entryTime = user ? user.entryTime : undefined
    // 需要脱敏的的员工id都为0
    if(Number(userId) === 0) return '腾讯员工';
    return <span>{showName ? <span className="UserInfo">{name || userId}</span> : <DateTime dateTime={entryTime} />}</span>
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.userRepo[ownProps.userId],
    userRepo: state.userRepo,
  }
}

export default withApi(connect(mapStateToProps)(UserInfo))
